import store from 'store';
import expirePlugin from 'store/plugins/expire';

store.addPlugin(expirePlugin);

class Storage {
  get = (key, emptyValue = null) => {
    return store.get(key) || emptyValue;
  };

  set = (key, value) => {
    store.set(key, value);
  };

  setExpires = (key, value, seconds) => {
    const expiration = new Date().getTime() + parseInt(seconds) * 1000;
    store.set(key, value, expiration);
  };

  remove = (key) => {
    store.remove(key);
  };

  clearAll = () => {
    store.clearAll();
  };

  each = (callback) => {
    store.each(callback);
  }
}

export default new Storage();
